<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "@/router/index.js";
import moment from "moment";
import YTAddress from "@/components/YTAddress/index.vue";
import {listAlliance, updateAllianceAssignee} from "@/api/alliance/alliance.js";
import {userInfoStore} from "@/store/store.js";
const userInfo = ref(userInfoStore().info);

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  keyword: null,
  applicationType: null,
  address: null,
  provinceCode: null,
  cityCode: null,
  districtCode: null,
  applyTime: [],

});
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {
      keyword: formData.keyword,
      applicationType: formData.applicationType,
      provinceCode: formData.provinceCode,
      cityCode: formData.cityCode,
      districtCode: formData.districtCode,
      startApplyTime: formData.applyTime.length > 0 ? moment(formData.applyTime[0]).format("YYYY-MM-DD") : null,
      endApplyTime: formData.applyTime.length > 0 ? moment(formData.applyTime[1]).format("YYYY-MM-DD") : null,
    }
    const res = await listAlliance(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.applicationType = null
  formData.provinceCode = null
  formData.cityCode = null
  formData.districtCode = null
  formData.applyTime = []
  YTAddressRef.value.cleanSelect()
  handleSearch('btnSearch')
}
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  formData.address = data.value
  formData.provinceCode = data.value[0]
  formData.cityCode = data.value[1]
  formData.districtCode = data.value[2] ? data.value[2] : null
}
// 合作类型枚举
const cooperationType = [
  {
    label: "驿站",
    value: "STATION"
  },
  {
    label: "车店",
    value: "BIKE_STORE"
  },
  {
    label: "理疗师",
    value: "THERAPIST"
  },
  {
    label: "俱乐部",
    value: "CLUB"
  },
  {
    label: "品牌",
    value: "BRAND"
  },
  {
    label: "服务商",
    value: "SERVICE_PROVIDER"
  },
  {
    label: "网球场馆",
    value: "TENNIS_COURT"
  }
]
// 处理合作类型枚举反显中文
const handleReviewCooperation = (type) => {
  return cooperationType.find(i => i.value === type).label
}
// 地址组件锚点
const YTAddressRef = ref()

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '名称', key: 'allianceApplicationName', nowrap: true },
  { title: '合作身份类型', key: 'applicationType', nowrap: true },
  { title: '所在位置', key: 'area', nowrap: true },
  { title: '负责人/联系人', key: 'contactName', nowrap: true },
  { title: '联系电话', key: 'contactPhone', nowrap: true },
  { title: '提交时间', key: 'crTime', nowrap: true },
  { title: '跟进', key: 'isFollowedUp', nowrap: true },
  { title: '跟进员工', key: 'assigneeName', nowrap: true },
  { title: '操作', key: 'controls', width: "120px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏*/
const setFollow = async (item) => {
  try {
    if (item.isFollowedUp) {
      // 跟进取消
      await updateAllianceAssignee(item.allianceApplicationId, false)
    } else {
      // 跟进确认
      await updateAllianceAssignee(item.allianceApplicationId, true)
    }
    ElMessage.success(item.isFollowedUp ? "跟进取消成功" : "跟进确认成功")
    handleSearch()
  } catch (e) {
    console.log(e)
  }
}

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="width: 100%;text-align: left"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <div class="flex_left flex_warp">
        <el-form-item label="关键词：" prop="keyword">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.keyword" placeholder="关键词搜索"></el-input>
        </el-form-item>
        <el-form-item label="合作身份类型：" prop="applicationType">
          <el-select class="mg_r_2" v-model="formData.applicationType" placeholder="请选择订单状态" style="width: 300px">
            <el-option
                v-for="item in cooperationType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所在位置：">
          <div class="mg_r_2" style="width: 300px">
            <YTAddress ref="YTAddressRef" :title="'所在位置'" :address-code="formData.address" @select="handleSelectAddress"></YTAddress>
          </div>
        </el-form-item>
        <el-form-item label="提交时间：" prop="applyTime">
          <el-date-picker
              v-model="formData.applyTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          />
        </el-form-item>
      </div>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.applicationType="{item}">
            {{ handleReviewCooperation(item.applicationType) }}
          </template>

          <template v-slot:item.area="{item}">
            {{ item.area?.province }}{{ item.area?.city }}{{ item.area?.district }}
          </template>

          <template v-slot:item.isFollowedUp="{item}">
            {{ item.isFollowedUp ? "是" : "否" }}
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-popconfirm @confirm="setFollow(item)" :title="`确定跟进取消 “${item.allianceApplicationName}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="跟进确认"
                        placement="left">
                      <v-icon class="cursor-pointer" v-if="!item.isFollowedUp" icon="mdi-link-variant" color="primary" size="small"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm @confirm="setFollow(item)" :title="`确定跟进取消 “${item.allianceApplicationName}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="跟进取消"
                        placement="left">
                      <v-icon class="cursor-pointer" v-if="item.isFollowedUp && item.assigneeId === userInfo.adminId" icon="mdi-link-variant-off" color="error" size="small"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>
